module.exports = __webpack_public_path__ + "static/media/tbg.988e708d.png";